"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Burger = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Burger = function Burger(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0581 7.88383H4.94192C4.42171 7.88383 4 7.46212 4 6.94192C4 6.42171 4.42171 6 4.94192 6H19.0581C19.5783 6 20 6.42171 20 6.94192C20 7.46212 19.5783 7.88383 19.0581 7.88383ZM19.0581 12.5934H4.94192C4.42171 12.5934 4 12.1717 4 11.6515C4 11.1313 4.42171 10.7096 4.94192 10.7096H19.0581C19.5783 10.7096 20 11.1313 20 11.6515C20 12.1717 19.5783 12.5934 19.0581 12.5934ZM4.94192 17.303H19.0581C19.5783 17.303 20 16.8813 20 16.3611C20 15.8409 19.5783 15.4192 19.0581 15.4192H4.94192C4.42171 15.4192 4 15.8409 4 16.3611C4 16.8813 4.42171 17.303 4.94192 17.303Z"
  }));
};

exports.Burger = Burger;